let env = 'produce';
//let env = 'develop';

const config = {
    domain: {
        produce: 'https://h5.huhustory.com/',
        develop: 'https://h5devel.huhustory.com/',
        local: 'https://h5devel.huhustory.com/',
    },
    href: {
        produce: 'https://m1.huhustory.com/',
        develop: 'https://m1devel.huhustory.com/',
        local: 'http://localhost:3000/'
    },
    wxAuthorizeBaseUrl: {
        produce: 'http://h5.huhustory.com/huhuapi/Wechat/index',
        develop: 'http://weixin.huhustory.com/agent/wxauthorize.php',
        local: ''
    },
    wxAppId: {
        produce: 'wx952b14da7b61c151',
        develop: 'wx952b14da7b61c151',
        local: ''
    },
    cookiePrefix: {
        produce: 'produce',
        develop: 'develop',
        local: 'local'
    },
    debugProcess: {
        produce: false,
        develop: false,
        local: true
    }
}

export const global = {
    domain: config.domain[env],
    href: config.href[env],
    cookiePrefix: config.cookiePrefix[env],
    wxAppId: config.wxAppId[env],
    wxAuthorizeBaseUrl: config.wxAuthorizeBaseUrl[env],
    debugProcess: config.debugProcess[env],
    currency: '呼呼豆',
    shareBaseUrl: config.href[env] + 'share/download',
    shareHomeUrl: config.href[env] + 'share/index',
    shareCallApp: config.href[env] + 'share/awaken',
    secret: "H!w%7s9*2!-bAa!@S9G70)-Kjd90-!9jieKo"
}